import { ROUTER_PATHS } from '../routes/routes.constatns';
import { Partner } from '../apis/models/partner/res/Partner';

const OCEAN_PARTNER_ID = 166;

export enum ForeignerNamingParseRules {
  // 전체 대문자 처리 (기본)
  ALL_UPPER_CASE = 'ALL_UPPER_CASE',
  // 성 대문자 + 이름 공백기준 첫글자 대문자 (오션)
  LAST_NAME_UPPER_CASE_AND_FIRST_NAME_FIRST_LETTER_UPPER_CASE = 'LAST_NAME_UPPER_CASE_AND_FIRST_NAME_FIRST_LETTER_UPPER_CASE',
}

const OCEAN_CLINIC_HARD_CODED_CONSTANTS = {
  RESERVATION_NOTICE: {
    ko:
      '📌 안내사항' +
      '\n\n🔹 토요일 / 평일 오전 / 당일 예약 시 상담 및 시술까지 다소 대기 시간이 생길 수 있습니다.' +
      '\n🔹 해피아워: 월~금 12PM–5PM 적용 (공휴일 제외)' +
      '\n🔹 화수목 이벤트: 화,수,목 종일 적용 (공휴일 제외)',

    en:
      '📌 Notice' +
      '\n\n🔹 Sat, weekday mornings, or same-day appointments may involve longer wait times.' +
      '\n🔹 Happy Hour: Mon–Fri, 12PM–5PM (holidays excluded)' +
      '\n🔹 TueWedThu Promo: Tue,Wed,Thu All day (holidays excluded)',

    ja:
      '📌 お知らせ' +
      '\n\n🔹 土曜・平日午前・当日予約の際は、相談や施術の前にお待ちいただく場合がございます。' +
      '\n🔹 ハッピーアワー：平日12PM–5PMのみ（祝日は対象外）' +
      '\n🔹 火水木イベント：火・水・木曜日終日のみ（祝日は対象外）',
    zh:
      '📌 须知事项' +
      '\n\n🔹 周六 / 工作日上午 / 当天预约时，可能会在咨询及施术前出现一定的等待时间。还请您多多包涵与理解。' +
      '\n🔹 限时活动: 适用于周一至周五12PM–5PM期间，但不包括公休日。' +
      '\n🔹 周二三四活动: 适用于周二三四的全天，但不包括公休日。',
    'zh-tw':
      '📌 須知事項' +
      '\n\n🔹 週六 / 平日上午 / 當天預約時，可能會在諮詢及施術前出現一定的等待時間。還請您多多包涵與理解。' +
      '\n🔹 限時活動: 適用於週一至週五12PM–5PM期間，但不包括公休日。' +
      '\n🔹 週二三四活動: 適用於週二三四的全天，但不包括公休日。',
  },
};

/**
 * 오션 의원 예약 완료 후 안내 문구 별도 처리
 */
export const renderHardCodedReservationNotice = (
  languageCode: string,
  partnerId: number,
) => {
  const notices = OCEAN_CLINIC_HARD_CODED_CONSTANTS.RESERVATION_NOTICE;
  // 안내 문구가 없는 언어는 영어로 노출
  const text = notices[languageCode as keyof typeof notices] ?? notices.en;

  if (text && partnerId === OCEAN_PARTNER_ID) {
    return (
      <div className="bg-white my-4 px-4 py-5 rounded-[20px] whitespace-pre-wrap text-sm font-medium text-gray-700">
        {text}
      </div>
    );
  }

  return '';
};

/**
 * 시술 예약하기시 병원별 라우팅 별도 처리
 */

export const getTreatmentReservationPath = (partner: Partner) => {
  if (partner.productViewConfig?.mimoWebViewConfig?.useProductListViewable) {
    return ROUTER_PATHS.EVENT_TREATMENT_RESERVATION;
  }

  return ROUTER_PATHS.TREATMENT_RESERVATION;
};

/**
 * 해외 고객 이름 관리 규칙
 */
const getForeignerNamingRule = (partnerId: number) => {
  if (partnerId === OCEAN_PARTNER_ID) {
    return ForeignerNamingParseRules.LAST_NAME_UPPER_CASE_AND_FIRST_NAME_FIRST_LETTER_UPPER_CASE;
  }
  return ForeignerNamingParseRules.ALL_UPPER_CASE;
};

export const parseLastName = (partnerId: number, lastName: string) => {
  const rule = getForeignerNamingRule(partnerId);

  if (
    rule ===
    ForeignerNamingParseRules.LAST_NAME_UPPER_CASE_AND_FIRST_NAME_FIRST_LETTER_UPPER_CASE
  ) {
    return lastName.toUpperCase();
  }

  if (rule === ForeignerNamingParseRules.ALL_UPPER_CASE) {
    return lastName.toUpperCase();
  }

  return lastName;
};

export const parseFirstName = (partnerId: number, firstName: string) => {
  const rule = getForeignerNamingRule(partnerId);

  if (
    rule ===
    ForeignerNamingParseRules.LAST_NAME_UPPER_CASE_AND_FIRST_NAME_FIRST_LETTER_UPPER_CASE
  ) {
    if (!firstName) {
      return firstName;
    }
    return firstName
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  if (rule === ForeignerNamingParseRules.ALL_UPPER_CASE) {
    return firstName.toUpperCase();
  }
  return firstName;
};
